import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from 'src/app/_service/leads.service';
import { DentalService } from 'src/app/_service/dental.service';
declare var $: any;
@Component({
  selector: 'app-ods-scan-logs',
  templateUrl: './ods-scan-logs.component.html',
  styleUrls: ['./ods-scan-logs.component.css']
})
export class OdsScanLogsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;

  search: string; start_date: string = ''; end_date: string = '';
  perpage: number = 25; scanBookList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circles = []; circles_copy = []; circle = '';

  constructor(private sharedapi: SharedService, private dentalapi: DentalService, public leadapi: LeadsService) { }

  ngOnInit(): void {
    this.getcircle();
  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  async loadScanBookList(pageIndex, perpage) {
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&circle=' + this.circle + '&date_range=' + this.start_date + '-' + this.end_date;
    this.loading = true; this.loaded = false;
    await this.dentalapi.loadOrthodontistScanBooks(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.scanBookList = data.data;
      } else {
        this.scanBookList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    }
  }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    }
  }

  ngAfterViewInit() {
    this.loadScanBookList(0, this.perpage);
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadScanBookList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadScanBookList(event.pageIndex, event.pageSize);
  }

  dateRangeChange(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }
  clearDate() {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

  resetFilters() {
    this.search = ''; this.circle = ''; this.clearDate();
    this.loadScanBookList(0, 25);
  }


}
